import { BaseComponent } from '../../../components/BaseComponent';
import { Modal, ModalControls } from '../../../components/Modal';
import { HBox, VBox } from '../../../components/Box';
import { UserSelection } from '../../Users/components/UserSelection';
import { Button } from '../../../components/Buttons';
import { WithCompany } from '../../Companies/components/WithCompany';
import { Well } from '../../../components/Well';
import { CompanyLabel } from '../../Companies/components/CompanyLabel';
import { UserLabelById } from '../../Users/components/UserLabelById';
import { Sync } from '../../../components/Icon';
import { FormField } from '../../../components/FormFields';
import { Checkbox } from '../../../components/Checkbox';
import { VehicleCreateFieldCompanyUser } from '../../Vehicles/pages/create/FieldCompanyUser';
import { Input } from '../../../components/Input';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import { INVOICE_DIRECTIONS } from '../../Invoices/constants';
import React from 'react';
import { Loader } from '../../../components/Loader';

const Container = styled.div`
  .button-sync {
    margin: 0px;
  }
  visibility: ${props => (props.customerModal ? 'hidden' : '')};

  .message {
    max-width: 400px;
    margin: 10px 0;
  }
`;

const STATE = {
  selectUser: false,
  addUser: null,
  showCustomerModal: false,
  emailContact: null,
};

/* eslint-disable react/prefer-stateless-function */
class ProductInvoiceEmailModalComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {}

  selectUser(user) {
    this.setState({ emailContact: user });
    this.reset();
  }

  reset() {
    this.setState({ selectUser: false, addUser: null });
  }

  onResetValues() {
    [
      'client',
      'email_contact',
      'financial_contact',
      'includeEmailContact',
      'includeFinancialContact',
      'includeManual',
      'outgoingCompanyId',
      'send_to_email',
    ].map(type => this.props.setValue('', type));
    return this.props.reset();
  }

  renderAddUser() {
    if (!this.state.selectUser) return null;
    return (
      <Modal title={this.lbl('company.users.delete.confirm.title')}>
        {this.state.addUser?.id ? (
          <VBox>{this.state.addUser?.email_address}</VBox>
        ) : (
          <UserSelection onSelect={user => this.setState({ addUser: user })} />
        )}
        <ModalControls>
          <Button disabled={!this.state.addUser?.id} onClick={() => this.selectUser(this.state.addUser)}>
            {this.lbl('add')}
          </Button>
          <Button onClick={this.reset.bind(this)}>{this.lbl('cancel')}</Button>
        </ModalControls>
      </Modal>
    );
  }

  get emailContact() {
    return this.state.emailContact || this.props.invoice.emailContact;
  }

  get emailTo() {
    return this.state.emailToChanged ? this.state.emailTo : this.props.invoice.emailTo;
  }
  get onCompleteDisabled() {
    return !this.emailContact && !this.emailTo;
  }

  onComplete() {
    const dto = {
      emailContactId: this.emailContact?.id ?? null,
      emailTo: this.emailTo ?? null,
    };

    this.props.onComplete(dto);
  }

  onClose() {
    this.props.onClose();
  }

  onChangedEmailTo(evt) {
    this.setState({ emailTo: evt.target.value, emailToChanged: true });
  }

  render() {
    if (this.props.invoice.direction === INVOICE_DIRECTIONS.INCOMING && (this.props.busy || this.props.sending))
      return <Loader />;
    const targetCompanyId =
      this.props.invoice.direction === INVOICE_DIRECTIONS.OUTGOING
        ? this.props.invoice.outgoingCompanyId
        : this.props.invoice.incomingCompanyId;

    const targetCompany =
      this.props.invoice.direction === INVOICE_DIRECTIONS.OUTGOING
        ? this.props.invoice.outgoingCompany
        : this.props.invoice.incomingCompany;

    return (
      <Modal onClose={this.onClose.bind(this)}>
        <WithCompany companyId={targetCompanyId} loader>
          <Well>
            <CompanyLabel company={targetCompany} />
          </Well>
          {this.renderAddUser()}
          <>
            <VBox>
              <span style={{ marginBottom: '5px', fontWeight: '400' }}>
                {this.lbl(`vehicle.order.property.send_to_email`)}
              </span>

              <div style={{ display: 'flex', marginBottom: '24px ' }}>
                <UserLabelById order user_id={this.emailContact?.id} key={this.emailContact?.id} />
                <Button small onClick={() => this.setState({ selectUser: true })}>
                  <Sync />
                </Button>
              </div>
            </VBox>
            <FormField>
              <Input
                type="email"
                style={{ width: 'auto' }}
                value={this.emailTo ?? ''}
                onChange={this.onChangedEmailTo.bind(this)}
              />
            </FormField>
          </>
          <ModalControls>
            <Button disabled={this.onCompleteDisabled} onClick={this.onComplete.bind(this)}>
              {this.lbl('send')}
            </Button>
          </ModalControls>
        </WithCompany>
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const ProductInvoiceEmailModal = compose(withConnect, withRouter)(ProductInvoiceEmailModalComp);
